import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import MailConfiguration from "../pages/MailConfiguration";
import NavBar from "../components/NavBar";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "Mail",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={null}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <MailConfiguration />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
